"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Link = (props) => {
    const { linkType, className } = props;
    const linkClasses = classnames_1.default({
        [`${className}`]: !!className,
        link: linkType !== 'inline-text',
        [`link-${linkType}`]: !!linkType,
    });
    return renderLink();
    function renderLink() {
        if (props.type === 'external') {
            return (React.createElement("a", { target: props.target, rel: props.target === '_blank' ? 'noopener noreferrer' : undefined, href: props.url, className: linkClasses },
                React.createElement("span", null, props.children)));
        }
        return (React.createElement(react_router_dom_1.Link, { className: linkClasses, to: props.url },
            React.createElement("span", null, props.children)));
    }
};
exports.Link = Link;
//# sourceMappingURL=Link.js.map